export enum BasketStatus {
  Selection = "Selection",
  Option = "Option",
  Ready = "Ready",
}
